type TabKey = 'foot' | 'shoes' | 'gallery';

type PageScenes = {
  foot: { recordType?: 'latest' | 'list' };
  shoes: { shoesId?: number };
  gallery: { galleryId?: number };
};

type RecordRouteParams = { [K in TabKey]: { tabKey: K } & PageScenes[K] }[TabKey];

export const generateRecordRoute = (params: RecordRouteParams): string => {
  const urlParams = new URLSearchParams({ tabKey: params.tabKey });

  if (params.tabKey === 'foot' && 'recordType' in params && params.recordType) {
    urlParams.set('recordType', params.recordType);
  }
  if (params.tabKey === 'shoes' && 'shoesId' in params && params.shoesId) {
    urlParams.set('shoeId', params.shoesId.toString());
  }
  if (params.tabKey === 'gallery' && 'galleryId' in params && params.galleryId) {
    urlParams.set('galleryId', params.galleryId.toString());
  }

  return `/record?${urlParams.toString()}`;
};
